import "../scss/global.scss"
import {AjaxRequest} from "./ajax-request";
import {getItem} from "./localStorage";
import {lang, translations} from "./translations";


const ajax = new AjaxRequest();


const user = document.querySelector('.user');
const userInfo = user.querySelector('.user_info');
const userName = document.querySelector('#name_user');


user.addEventListener('click', () => {
    userInfo.classList.toggle('active');
    if (userInfo.classList.contains('active')) {
        let name = getItem('user');
        name ? userName.innerHTML = name : userName.innerHTML = "";

    }
})

const logOut = document.querySelectorAll('#logOut');
const spinner = document.querySelector('.spinner');


if (logOut) {
    logOut.forEach(item => {
        item.addEventListener('click', async () => {
            spinner.style.display = "d-flex";
            try {
                let response = await ajax.request('my_ajax_logout');
                spinner.style.display = "none";
                if (response['success']) {
                    window.location.href = "/"
                }
            } catch (error) {
                spinner.style.display = "none";
            }
        })
    })
}


let boxes = document.querySelectorAll('.cookies .feature');
boxes.forEach((box, i) => {
    box.addEventListener('click', (e) => {

        box.classList.toggle('active')
        boxes.forEach((item, j) => {
            if (i !== j)
                item.classList.remove('active')
        })
    })
})


const btnPreferences = document.querySelector('.app-button.preferences');
const preferences = document.querySelector('#preferences');
const mainCookiesContent = document.querySelector('#main_cookies')

const cookiesManiBtns = document.querySelectorAll('#main_btn_cookies');
const savePreferencesBtn = document.querySelector('#save_cookies')
const cancelPreferencesBtn = document.querySelector('#cancel_cookies')


btnPreferences.addEventListener('click', () => {
    preferences.classList.toggle('active');
    mainCookiesContent.classList.toggle('active');

    if (preferences.classList.contains('active')) {
        cookiesTitle.innerHTML = translations[lang].cookiesPreferences;
        cookiesManiBtns.forEach(btn => btn.style.display = "none");
        savePreferencesBtn.style.display = 'inline-block'
        cancelPreferencesBtn.style.display = 'inline-block'
    } else {
        cookiesTitle.innerHTML = translations[lang].cookiesTitle;
        cookiesManiBtns.forEach(btn => btn.style.display = "inline-block");
        savePreferencesBtn.style.display = 'none'
    }

})


savePreferencesBtn.addEventListener('click', () => {
    savePreferences();

})
cancelPreferencesBtn.addEventListener('click', () => {
    cookiesManiBtns.forEach(btn => btn.style.display = "inline-block");
    savePreferencesBtn.style.display = 'none'
    cancelPreferencesBtn.style.display = 'none'
    preferences.classList.toggle('active');
    mainCookiesContent.classList.toggle('active');
})


function getCookie(cookieName) {
    let cookie = {};
    document.cookie.split(';').forEach(function (el) {
        let [key, value] = el.split('=');
        cookie[key.trim()] = value;
    })
    return cookie[cookieName];
}

let cookiesBanner = document.querySelector('.cookies');
let cookiesPreferencesIndex = 0;
let cookies = getCookie('cookie_wall');
// let cookies0 = getCookie('active-0');
// let cookies1 = getCookie('active-1');
// let cookies2 = getCookie('active-2');
// let cookies3 = getCookie('active-3');

if (!cookies) {
    cookiesBanner.style.display = "block";
    document.querySelector('body').classList.add('overflow-hidden');
}


const cookieAccept = document.querySelector(".cookies button.accept");
let cookiesTitle = document.querySelector('#cookiesTitle');
const cookieDismiss = document.querySelector(".cookies button.dismiss");
const allCookiesType = document.querySelectorAll('#preferences input');

cookieDismiss.addEventListener('click', () => {
    cookiesBanner.style.display = "none";
    document.querySelector('body').classList.remove('overflow-hidden');
})


cookieAccept.addEventListener('click', () => {
    acceptedCookiesWall();
})


allCookiesType.forEach(input => {
    input.addEventListener('click', () => {
        let type = input.getAttribute('data-type');
        let id = parseInt(input.getAttribute('data-id'));
        if (input.checked) {
            while (id > 0) {
                allCookiesType[id - 1].checked = true;
                id--
            }
        } else {
            let length = allCookiesType.length
            while (length > id) {
                allCookiesType[length - 1].checked = false;
                length--
            }
        }
        cookiesPreferencesIndex = parseInt(input.getAttribute('data-id'));
    })
})


function savePreferences() {
    let inputData = {action: "my_ajax_savePreferences"};
    let cookiesData = [];
    // allCookiesType.forEach((input, i) => {
    //     let type = input.getAttribute('data-type');
    //     if (input.checked) {
    //         cookiesData.push(`active-${i}`)
    //         inputData['cookies'] = cookiesData;
    //     }
    // })

    inputData['cookiesPreferencesIndex'] = cookiesPreferencesIndex;
    let requestData = new URLSearchParams(inputData).toString();
    $.ajax({
        url: ajaxurl,
        type: 'POST',
        dataType: 'json',
        data: requestData,
        success: function () {
            if (cookiesPreferencesIndex === 4) {
                loadGTM();
            }
            cookiesBanner.style.display = "none";
            document.querySelector('body').classList.remove('overflow-hidden');
        },
        error: function () {
            cookiesBanner.style.display = "none";
            document.querySelector('body').classList.remove('overflow-hidden');
        }
    });
}


function acceptedCookiesWall() {
    let inputData = {action: "setCookie"}
    let requestData = new URLSearchParams(inputData).toString();
    $.ajax({
        url: ajaxurl,
        type: 'POST',
        dataType: 'json',
        data: requestData,
        success: function () {
            loadGTM();
            cookiesBanner.style.display = "none";
            document.querySelector('body').classList.remove('overflow-hidden');
        },
        error: function () {
        }
    });
}


const toggles = document.querySelectorAll('.toggle');


toggles.forEach(item => {
    item.addEventListener('click', (e) => {
        e.stopPropagation();
    })
});


function loadGTM() {
    // Kod GTM na końcu sekcji <head>
    // Dodanie skryptu GTM na końcu <head>
    var gtmScript = document.createElement('script');
    gtmScript.innerHTML = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-K4L7Q3Z7');";
    document.head.appendChild(gtmScript);
    

    debugger
}







